import { render, staticRenderFns } from "./IconSortAsc.vue?vue&type=template&id=7dd072c6&"
import script from "./IconSortAsc.vue?vue&type=script&lang=js&"
export * from "./IconSortAsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd072c6')) {
      api.createRecord('7dd072c6', component.options)
    } else {
      api.reload('7dd072c6', component.options)
    }
    module.hot.accept("./IconSortAsc.vue?vue&type=template&id=7dd072c6&", function () {
      api.rerender('7dd072c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSortAsc.vue"
export default component.exports